import { ComponentPropsWithoutRef } from 'react';

import classNames from 'classnames';

type Props = ComponentPropsWithoutRef<'button'> & {
  isLoading?: boolean;
  variant?: 'primary' | 'secondary';
};

export const ListItemButton = ({ isLoading, variant = 'primary', className, ...props }: Props) => {
  return (
    <button
      className={classNames(
        `msq-btn msq-btn-${variant} msq-btn-md w-[160px] max-sm:w-full`,
        isLoading && 'msq-btn-loading',
        className,
      )}
      {...props}
    >
      {props.children}
    </button>
  );
};
